import { Button, Col, Form, Row } from 'react-bootstrap';

// common/v7 booking_availability — the owner's editor for date ranges this listing is closed /
// unavailable (scheduled maintenance, renovation, a festival break, owner use). These grey out
// in the customer's date picker with `reason` as the tooltip, and a booking that would overlap
// is rejected. Ported from gym's original (rentalui/gym/src/components/BlockedDatesFields.js).

const KINDS = [
  ['maintenance', 'Maintenance'],
  ['renovation', 'Renovation'],
  ['seasonal', 'Seasonal / festival break'],
  ['owner_use', 'Reserved by owner'],
  ['other', 'Other']
];

export const emptyBlockedRow = () => ({ from: '', to: '', kind: 'maintenance', reason: '' });

// Drop incomplete rows and coerce to the API shape.
export function sanitizeBlockedDates(rows) {
  return (rows || [])
    .filter((r) => r.from && r.to)
    .map((r) => ({ from: r.from, to: r.to, kind: r.kind || 'other', reason: (r.reason || '').trim() }));
}

export default function BlockedDatesFields({ value = [], onChange }) {
  const rows = value.length ? value : [];
  const set = (i, key, v) => onChange(rows.map((r, idx) => (idx === i ? { ...r, [key]: v } : r)));
  const add = () => onChange([...rows, emptyBlockedRow()]);
  const remove = (i) => onChange(rows.filter((_, idx) => idx !== i));

  return (
    <Form.Group className="mb-3">
      <Form.Label>Closed / unavailable date ranges</Form.Label>
      <Form.Text className="d-block text-muted mb-2">
        Customers can&apos;t book a date that overlaps these, and the dates show as unavailable on
        the booking calendar.
      </Form.Text>
      {rows.length === 0 && <div className="small text-muted mb-2">None — this listing is available on every date.</div>}
      {rows.map((r, i) => (
        <Row key={i} className="g-2 mb-2 align-items-end">
          <Col xs={6} md={3}>
            <Form.Label className="small mb-0">From</Form.Label>
            <Form.Control type="date" size="sm" value={r.from} onChange={(e) => set(i, 'from', e.target.value)} />
          </Col>
          <Col xs={6} md={3}>
            <Form.Label className="small mb-0">To</Form.Label>
            <Form.Control type="date" size="sm" min={r.from} value={r.to} onChange={(e) => set(i, 'to', e.target.value)} />
          </Col>
          <Col xs={6} md={2}>
            <Form.Label className="small mb-0">Reason type</Form.Label>
            <Form.Select size="sm" value={r.kind} onChange={(e) => set(i, 'kind', e.target.value)}>
              {KINDS.map(([k, label]) => <option key={k} value={k}>{label}</option>)}
            </Form.Select>
          </Col>
          <Col xs={5} md={3}>
            <Form.Label className="small mb-0">Note (shown to customers)</Form.Label>
            <Form.Control size="sm" value={r.reason} maxLength={200} onChange={(e) => set(i, 'reason', e.target.value)} placeholder="e.g. annual servicing" />
          </Col>
          <Col xs={1}>
            <Button variant="outline-danger" size="sm" onClick={() => remove(i)} aria-label="Remove">✕</Button>
          </Col>
        </Row>
      ))}
      <Button variant="outline-secondary" size="sm" onClick={add}>+ Add a closed range</Button>
    </Form.Group>
  );
}
